/**
 * List Schema of CargaSaraiva
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {CargaSaraiva} from '@/model/resource/CargaSaraiva'

/* TODO: review generated schema */
export class ListCargaSaraivaSchema extends Schema {
  readonly name = 'ListCargaSaraiva'

  readonly fieldSet: FieldSet<CargaSaraiva> = {
    idCargaPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    dataCriacao: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.dataCriacao),
      },
    }),
    ativo: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.ativo),
      },
    }),
    danfe: (): FieldComponent => ({
      is: Component.Render,
    }),
    notaFiscal: (): FieldComponent => ({
      is: Component.Render,
    }),
    nomeDestinatario: (): FieldComponent => ({
      is: Component.Render,
    }),
    documentoDestinatario: (): FieldComponent => ({
      is: Component.Render,
    }),
    enderecoDestinatario: (): FieldComponent => ({
      is: Component.Render,
    }),
    nomeTransportador: (): FieldComponent => ({
      is: Component.Render,
    }),
  }
}
